module.exports = "<button mat-raised-button>Click me!</button>"